module.exports = __webpack_public_path__ + "img/kl_wlwz.210e69f9.png";